import priceLists from "../../api/priceLists";

export default {
  namespaced: true,
  state: {
    items: [],
    editedId: -1,
    currentList: null,
    priceListProducts: [],
    currentContract: null,
    editedItem: {
      Id: null,
      name: "",
      startDate: new Date(),
      endDate: new Date(new Date().getFullYear() + 1, 0, 15), // 14th February of next year
      fK_Customer: null,
    },
    defaultItem: {
      Id: null,
      name: "",
      startDate: new Date(),
      endDate: new Date(new Date().getFullYear() + 1, 0, 15),
      fK_Customer: null,
    },
  },
  mutations: {
    setItems(state, items) {
      state.items = items;
    },
    setEditedItem(state, item) {
      const editedItem = {
        Id: item.id,
        startDate: item.startDate,
        endDate: item.endDate,
        fK_Customer: item.fK_Customer,
      };
      state.editedItem = editedItem;
    },
    setEditedId(state, id) {
      state.editedId = id;
    },
    setCurrentList(state, id) {
      state.currentList = id;
    },
    setCustomer(state, customer) {
      state.editedItem.fK_Customer = customer;
    },
    setCustomerName(state, name) {
      state.editedItem.name = name;
    },
    setPriceListProducts(state, products) {
      state.priceListProducts = products;
    },
    setCurrentContract(state, contract) {
      state.currentContract = contract;
    },
  },
  actions: {
    fetchAll({ commit }, data) {
      return priceLists.get(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    fetchItemByCustomerId({ commit }, data) {
      return priceLists.getPriceListByCustomerId(data).then((response) => {
        commit("setItems", response.data);
        return response;
      });
    },
    getPriceListProductByPriceListId({ commit }, id) {
      return priceLists
        .getPriceListProductByPriceListId(id)
        .then((response) => {
          commit("setPriceListProducts", response.data);
          return response;
        });
    },
    updatePriceListProduct({ dispatch, state }, data) {
      return priceLists.updateProduct(data.id, data.price).then((response) => {
        dispatch("getPriceListProductByPriceListId", state.editedId);
        return response;
      });
    },
    saveEditedItem({ commit, state }) {
      // Formatage des dates au format YYYY-MM-DD
      const startDate = new Date(state.editedItem.startDate)
        .toISOString()
        .split("T")[0];
      const endDate = new Date(state.editedItem.endDate)
        .toISOString()
        .split("T")[0];
      const data = {
        fK_Contract: state.currentContract,
        startDate,
        endDate,
        name: state.editedItem.name + "_" + startDate + "_" + endDate,
      };
      return priceLists.store(data).then((response) => {
        commit("setCurrentList", response.data.id);
        return response;
      });
    },
    updateEditedItem({ dispatch, state }) {
      return priceLists
        .update(state.editedId, state.editedItem)
        .then((response) => {
          dispatch("fetchAll");
          dispatch("resetEditedItem");
          return response;
        });
    },
    deleteItem(context, id) {
      return priceLists.delete(id);
    },
    resetEditedItem({ commit, state }) {
      commit("setEditedId", -1);
      commit("setEditedItem", Object.assign({}, state.defaultItem));
    },
  },
};
